export const getExpectedTransportIDLength = (mode = 'auto') =>
   mode === 'auto' ? 17 : 12;

export const isValidTransportIDCharacters = (id) =>
   /^[A-HJ-NPR-Z0-9]*$/.test(id);

export const validateTransportID = (id, mode = 'auto') => {
   const expectedLength = getExpectedTransportIDLength(mode);
   if (id.length > 0 && id.length < expectedLength) {
      return `A ${mode === 'auto' ? 'VIN' : 'HIN'} must be exactly ${expectedLength} characters long.`;
   }
   if (id.length === expectedLength && !isValidTransportIDCharacters(id)) {
      return `Invalid ${mode === 'auto' ? 'VIN' : 'HIN'}. Ensure it does not contain I, O, or Q.`;
   }
   return '';
};
